<template>
    <job-info />
</template>

<script>
import JobInfo from "@/components/JobInfo.vue";

export default {
    components: {
        JobInfo,
    },
};
</script>

<style>
</style>